module.exports = __webpack_public_path__ + "static/media/goldenprize-tuna-springwater-lid.8d1e8781.png";